"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
var client_1 = require("@apollo/client");
var zen_observable_ts_1 = require("zen-observable-ts");
var toRequestKey = function (operation) {
    return operation.operationName;
};
/**
 * An Apollo link that enqueues mutations so that they cannot fire in parallel.
 *
 * To skip the queue pass `{ context: { skipQueue: true } }` to your mutation.
 */
var MutationQueueLink = /** @class */ (function (_super) {
    __extends(MutationQueueLink, _super);
    /**
     * @param {Boolean} debug - set to true to enable logging
     */
    function MutationQueueLink(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.debug, debug = _c === void 0 ? false : _c;
        var _this = _super.call(this) || this;
        _this.opQueue = [];
        _this.inProcess = false;
        _this.debug = false;
        _this.debug = debug;
        return _this;
    }
    MutationQueueLink.prototype.log = function (message) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        if (this.debug) {
            console.log.apply(console, __spreadArray([message], rest, false));
        }
    };
    MutationQueueLink.prototype.processOperation = function (entry) {
        var _this = this;
        var operation = entry.operation, forward = entry.forward, observer = entry.observer;
        this.inProcess = true;
        this.log("[PROCESSING] -", toRequestKey(operation));
        forward(operation).subscribe({
            next: function (result) {
                _this.inProcess = false;
                observer.next(result);
                _this.log("[NEXT] -", toRequestKey(operation));
                // If there are more operations, process them.
                if (_this.opQueue.length) {
                    _this.processOperation(_this.opQueue.shift());
                }
            },
            error: function (error) {
                _this.inProcess = false;
                observer.error(error);
                _this.log("[ERROR] -", toRequestKey(operation), error);
                // If there are more operations, process them.
                if (_this.opQueue.length) {
                    _this.processOperation(_this.opQueue.shift());
                }
            },
            complete: observer.complete.bind(observer)
        });
    };
    MutationQueueLink.prototype.cancelOperation = function (entry) {
        this.opQueue = this.opQueue.filter(function (e) { return e !== entry; });
    };
    MutationQueueLink.prototype.enqueue = function (entry) {
        this.log("[ENQUEUE] -", toRequestKey(entry.operation));
        this.opQueue.push(entry);
    };
    MutationQueueLink.prototype.request = function (operation, forward) {
        var _this = this;
        // Enqueue all mutations unless manually skipped.
        if (isMutation(operation) && !operation.getContext().skipQueue) {
            return new zen_observable_ts_1.Observable(function (observer) {
                var operationEntry = { operation: operation, forward: forward, observer: observer };
                if (!_this.inProcess) {
                    _this.processOperation(operationEntry);
                }
                else {
                    _this.enqueue(operationEntry);
                }
                return function () { return _this.cancelOperation(operationEntry); };
            });
        }
        else {
            return forward(operation);
        }
    };
    return MutationQueueLink;
}(client_1.ApolloLink));
exports["default"] = MutationQueueLink;
function isMutation(operation) {
    return operation.query.definitions.some(function (definition) {
        return definition.kind === "OperationDefinition" &&
            definition.operation === "mutation";
    });
}
//# sourceMappingURL=MutationQueueLink.js.map